import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";

import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import moment from "moment";
import { IconButton, Modal, Stack, Tooltip, Typography } from "@mui/material";
import { GetUnbayLoad_Receiver_User_GETROW } from "../../../Server/ApiV2";
import GCData from "./GCDataGrid";
import PrintIcon from "@mui/icons-material/Print";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useGridApiRef } from "@mui/x-data-grid-pro";

const GCLoadingBay = ({
  xOpen = false,
  fCloseLoadPoModal = () => {},
  xTitle = "Modal",
  Label = "User",
  xLabelValue = "",
  v_user,
  v_Date,
  v_LDBay,
  column = [],
}) => {
  const apiRef = useGridApiRef();
  const [sRow, setRow] = useState([]);

  const fonload = async (user, Date, LDBay) => {
    setRow([]);
    let obj = {
      v_user: user,
      v_Date: moment(Date).format("MM/DD/YYYY"),
      v_LDBay: LDBay,
    };
    const resp = await GetUnbayLoad_Receiver_User_GETROW(obj);
    if (resp?.status === 200) {
      let row = resp.data.ResultSet.recordset.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setRow(row);
      return row;
    }
  };

  const handleExport = () => {
    apiRef.current.exportDataAsCsv(); // or exportDataAsExcel(), etc.
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  useEffect(() => {
    if (xOpen) {
      fonload(v_user, v_Date, v_LDBay);
    }
  }, [xOpen, v_user, v_Date, v_LDBay]);

  return (
    <Modal
      open={xOpen}
      onClose={() => {
        fCloseLoadPoModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
      gnr-item-search 
      model-gc-search"
      >
        <GCTitleSticky
          title={xTitle}
          onClose={() => {
            fCloseLoadPoModal();
          }}
        />
        <Box display={"flex"} justifyContent={"space-around"}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "#1976d2",
              paddingTop: "10px",
              // textDecoration: "underline",
            }}
          >
            {Label} :{xLabelValue}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "#1976d2",
              paddingTop: "10px",
              // textDecoration: "underline",
            }}
          >
            GRNDate :{moment(v_Date.GRNDatet).format("DD//MM/YYYY")}
          </Typography>
        </Box>

        <div className="p-2">
          <Stack direction={"row"} justifyContent={"flex-end"}>
            <Tooltip title="Export">
              <IconButton color="primary" size="small" onClick={handleExport}>
                <FileDownloadIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" size="small" onClick={handlePrint}>
                <PrintIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <GCData
            Row={sRow}
            Column={column}
            apiRef={apiRef}
            onRowClick={(e) => {}}
            height={"70vh"}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default GCLoadingBay;
